export enum DesignationType {
  // Residential
  ResidentialApartments = "160",
  Recreation = "230",
  Residential1Flat = "110",
  Residential2Flats = "120",
  Residential3OrMoreFlats = "140",
  Hotels = "202",
  Administrative = "210",
  ManufacturingIndustry = "222",
  Manufacturing = "298",
  Other = "296",
  AmateurGardens = "266",
  ResidentialSocialGroups = "150",

  // Parking underground
  Garage = "220",
  // Parking above ground
  OtherEngineeringStructures = "590",
  // Storage
  OtherSubFarm = "270",

  // Plot area
  PlotArea = "995",
  ResidentialTerritory = "940",
  LowRiseTerritory = "950",
  MultiStoryTerritory = "953",
  Agricultural = "610",
  AgriculturalGardens = "612",
  CommercialActivity = "972",
  RecreationalBuildings = "968",
}

export enum REType {
  Flat = "1",
  House = "2",
}

export function getTransactionREType(designationType: DesignationType) {
  switch (designationType) {
    case DesignationType.Residential1Flat:
    case DesignationType.Residential2Flats:
    case DesignationType.Residential3OrMoreFlats:
    case DesignationType.AmateurGardens:
      return REType.House;
    default:
      return REType.Flat;
  }
}
